import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Award, Globe } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: BookOpen, label: 'Courses', value: '10+' },
    { icon: Users, label: 'Students', value: '500+' },
    { icon: Award, label: 'Certifications', value: '1000+' },
    { icon: Globe, label: 'Countries', value: '20+' }
  ];

  const team = [
    
  ];

  return (
    <div className="py-12 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mission Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">About JK SemiTech</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We are dedicated to providing high-quality technology education and empowering the next generation of tech professionals through practical, hands-on learning experiences.
          </p>
        </motion.div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center bg-gray-900 p-6 rounded-lg">
              <stat.icon className="h-8 w-8 text-blue-500 mx-auto mb-4" />
              <div className="text-3xl font-bold mb-2 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">{stat.value}</div>
              <div className="text-gray-300">{stat.label}</div>
            </div>
          ))}
        </motion.div>

        {/* Team Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text"></h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 * index }}
                className="bg-gray-900 rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2 text-white">{member.name}</h3>
                  <p className="text-gray-300">{member.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Vision Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg p-8 text-center"
        >
          <h2 className="text-3xl font-bold mb-4">Our Vision</h2>
          <p className="text-xl">
            To become the leading technology education platform, bridging the gap between theoretical knowledge and practical industry requirements, while fostering innovation and excellence in every student.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default About;